import { Countries } from '../../shared/libraries/countries';
import { User } from '../user';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class RegistrationSerializer extends BaseSerializer {
  deserialize(raw) {
    const success = raw?.statusCode == 201;
    let parsedUser = null;
    if (success)
      parsedUser = {
        id: raw?.data?.id,
        email: raw?.data?.email,
        firstName: raw?.data?.firstName,
        lastName: raw?.data?.lastName,
        phoneNumber: raw?.data?.phoneNumber,
        countryCode: raw?.data?.countryCode,
        createdAt: raw?.data?.createdAt,
        updatedAt: raw?.data?.updatedAt,
        metadata: {}
      };

    const errorTexts = success
      ? null
      : errorMessages[`${raw?.statusCode}`] || errorMessages.other;
    return {
      success,
      statusCode: raw?.statusCode || 500,
      message: success ? 'ok' : errorTexts?.message,
      errorTitle: errorTexts?.title,
      alreadyExists: raw?.statusCode === 409,
      user: success ? new User(parsedUser) : null
    };
  }

  serialize(data) {
    //     lastName
    // firstName
    // phonePrefix
    // phoneNumber
    // email
    // password
    // affiliationCode
    // whatsappNumber
    // acceptMoreThan18
    // termOfUse
    if (!data) return null;
    return {
      firstName: data.firstName,
      lastName: data.lastName,
      password: data.password,
      email: `${data.email}`.toLowerCase(),
      countryCode: Countries.getPhoneCountry(data.phonePrefix)?.countryCode,
      phoneNumber: `${data.phonePrefix}${data.phoneNumber}`,
      metadata: {
        affiliationCode: data.affiliationCode,
        whatsappNumber: data.whatsappNumber
      }
    };
  }
}
const errorMessages = {
  409: {
    title: 'Email déjà utilisé',
    message:
      'Cet email est déjà associé à un compte. Veuillez en utiliser un autre.'
  },
  400: {
    title: 'Erreur dans les données',
    message:
      'Les informations soumises sont invalides. Veuillez vérifier et réessayer.'
  },
  other: {
    title: "Échec de l'inscription",
    message: 'Une erreur inattendue s’est produite. Veuillez réessayer.'
  }
};

export const registrationSerializer = new RegistrationSerializer();
